import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";

export interface IPegRes {
  msg: string;
  data: {
    verificationResult: string;
  };
  status: string;
}

const useFetchPegPage = (billingCycleId: string) => {
  const [pegData, setPegData] = useState<IPegRes["data"] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { makeApiCall } = useApi({
    url: `/rtm/patient-dashboard/cron/pdf/v3/peg/${billingCycleId}`,
    method: "GET",
    preAuth: true,
  });

  const getPegData = useCallback(async () => {
    if (!billingCycleId) {
      console.log("No patientId provided, skipping PEG data fetch");
      return null;
    }

    setIsLoading(true);
    setError(null);

    try {
      const { response, error: apiError } = await makeApiCall<
        undefined,
        IPegRes
      >();

      if (apiError) {
        throw new Error(apiError.msg || "Failed to fetch PEG data");
      }

      if (response?.status === "success") {
        setPegData(response.data);
        return response.data;
      } else {
        throw new Error(response?.msg || "No PEG data available");
      }
    } catch (error: any) {
      console.error("Error in getPegData:", error);
      setError(error.message);
      // toast.error(error.message || "Unable to load PEG data. Please refresh and try again.");
      setPegData(null);
      return null;
    } finally {
      setIsLoading(false);
    }
  }, [billingCycleId, makeApiCall]);

  // useEffect(() => {
  //   if (billingCycleId) {
  //     getPegData();
  //   }
  // }, [billingCycleId, getPegData]);

  return {
    pegData,
    pegLoading: isLoading,
    error,
    refetch: getPegData,
  };
};

export default useFetchPegPage;
